import React, { Component } from "react";

//Import CSS
import "./index.css";

class NumericNavigationMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected_option: 1,
    };
  }
  handleChangeOption(option) {
    if (option !== this.state.selected_option) {
      if (this.props?.ChangeOption) {
        const changeAllowed = this.props.ChangeOption(option);
        if (changeAllowed !== false) {
          this.setState({
            selected_option: option,
          });
        }
      } else {
      this.setState({
        selected_option: option,
      });
      }
    }
  }
  getOptionsSelected = () => {
    return this.state.selected_option;
  };
  render() {
    return (
      <div className="numeric-navigation-menu_container">
        <div>
          <ul className="numeric-navigation-menu_ul slider-nav">
            {this.props?.menuOptions.map(option => (
              <li
                key={option.id}
                className={"numeric-navigation-menu_li " + (this.state.selected_option === option.id ? "selected" : "")}
                onClick={() => this.handleChangeOption(option.id)}>
                <a className="numeric-navigation-menu_link" href="#">
                <span className="link-number">{option.id}</span>
                  <p className="link-text">{option.label}</p>
                </a>
              </li>
            ))}
          </ul>
          <span className="numeric-navigation-menu_span"></span>
        </div>
        <div className="numeric-navigation-menu_selected-page">
          {this.props?.menuOptions.filter(option => option.id === this.state.selected_option).map(option => option.component)}
        </div>
      </div>
    );
  }
}

export default NumericNavigationMenu;
